import { render, staticRenderFns } from "./articleadd.vue?vue&type=template&id=7df65474&scoped=true&"
import script from "./articleadd.vue?vue&type=script&lang=js&"
export * from "./articleadd.vue?vue&type=script&lang=js&"
import style0 from "./articleadd.vue?vue&type=style&index=0&id=7df65474&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df65474",
  null
  
)

export default component.exports